<div class="card-header" *ngIf="debugging">
  <app-breadcrumb [currentPage]="
  'Diagnostiek ' +
  debugging.client.id + ' ' +
  debugging.client.firstNameInitials + ' ' +
  debugging.client.insertion + ' ' +
  debugging.client.lastName + ' ' +
  debugging.task.reportType +
  debugging.task.year + ' ' +
  (debugging.task.paid ? 'Betaald' : 'Niet betaald')"></app-breadcrumb>
</div>
<div class="card-body" *ngIf="debugging">

  <button
    [routerLink]="debugging.task.year ? '../../../' : '../../'"
    class="btn btn-left arrow-left">naar bewind</button>
  <div class="spacer"></div>

  <!-- summary -->
  <h2>Summary</h2>
  <table class="col-2-monospace spaced-table">
    <tr><td>totaal netto inkomen (A)</td><td>{{euro(debugging.summary.income)}}</td></tr>
    <tr><td>totaal uitgaven (B)</td><td>{{euro(debugging.summary.expenses)}}</td></tr>
    <tr><td>verschil (C)</td><td>{{euro(debugging.summary.differenceIncomeExpenses)}}</td></tr>
    <tr><td>totaal rekeningen einddatum (E)</td><td>{{euro(debugging.summary.endAmount)}}</td></tr>
    <tr><td>totaal rekeningen begindatum (D)</td><td>{{euro(debugging.summary.startAmount)}}</td></tr>
    <tr><td>verschil (F)</td><td>{{euro(debugging.summary.differenceStartEndAmount)}}</td></tr>
    <tr><td>F - C is</td><td>{{euro(debugging.summary.deviation)}}</td></tr>
  </table>
  <div class="spacer"></div>


  <!-- Asymmetric Internal Transactions -->
  <ng-container *ngIf="debugging.asymmetricInternalTransactions.length > 0">
    <h3>Asymmetric Internal Transactions</h3>
    <textarea>{{debugging.asymmetricInternalTransactions | json}}</textarea>
  </ng-container>
  <div class="spacer"></div>


  <!-- Accounts -->
  <h2>accounts</h2>
  <div *ngFor="let account of debugging.accounts">
    <div class="spacer"></div>
    <h3>{{account.account.accountCategory.name + ' ' + account.account.accountNumber + ' (' + account.account.id + ')'}}</h3>
    Sum: {{account.transactionAmountSum}} <br>
    Sum volgens Statements: {{account.balances.current.differenceStatement}} <br>
    Sum volgens Transactions: {{account.balances.current.differenceTransaction}}
    <br><br>
    Unassigned: {{account.thisYearsUnassignedTransactionCount}}
    <div class="spacer"></div>


    <!--Balances -->
   <table class="table full-width table-balance">
    <thead>
      <tr>
        <th></th>
        <th colspan="2" *ngIf="account.balances.previous">{{debugging.task.year -1}}</th>
        <th colspan="2">Nu</th>
        <th colspan="2" *ngIf="account.balances.next">{{debugging.task.year +1}}</th>
      </tr>
      <tr>
        <th></th>
        <ng-container *ngIf="account.balances.previous">
          <th>Start</th>
          <th>Eind</th>
        </ng-container>
        <th class="table-balance-now">Start</th>
        <th class="table-balance-now">Eind</th>
        <ng-container *ngIf="account.balances.next">
          <th>Start</th>
          <th>Eind</th>
        </ng-container>
      </tr>
    </thead>
     <tbody>
     <tr>
       <th>Statement</th>
       <ng-container *ngIf="account.balances.previous">
         <td>{{account.balances.previous.openingBalanceAccordingToFirstStatement}}</td>
         <td>{{account.balances.previous.closingBalanceAccordingToLastStatement}}</td>
       </ng-container>
       <td class="table-balance-now">{{account.balances.current.openingBalanceAccordingToFirstStatement}}</td>
       <td class="table-balance-now">{{account.balances.current.closingBalanceAccordingToLastStatement}}</td>
       <ng-container *ngIf="account.balances.next">
         <td>{{account.balances.next.openingBalanceAccordingToFirstStatement}}</td>
         <td>{{account.balances.next.closingBalanceAccordingToLastStatement}}</td>
       </ng-container>
     </tr>
     <tr>
       <th>Transaction</th>
       <ng-container *ngIf="account.balances.previous">
         <td>{{account.balances.previous.openingBalanceAccordingToFirstTransactionStatement}}</td>
         <td>{{account.balances.previous.closingBalanceAccordingToLastTransactionStatement}}</td>
       </ng-container>
       <td class="table-balance-now">{{account.balances.current.openingBalanceAccordingToFirstTransactionStatement}}</td>
       <td class="table-balance-now">{{account.balances.current.closingBalanceAccordingToLastTransactionStatement}}</td>
       <ng-container *ngIf="account.balances.next">
         <td>{{account.balances.next.openingBalanceAccordingToFirstTransactionStatement}}</td>
         <td>{{account.balances.next.closingBalanceAccordingToLastTransactionStatement}}</td>
       </ng-container>
     </tr>
     </tbody>
   </table>


    <!-- Internal Transactions -->
    <div class="spacer"></div>
    <h3>duplicates</h3>
    <div *ngFor="let potentialDuplicate of account.potentialDuplicateTransactions">
      <table class="table full-width">
        <tr>
          <th style="width: 150px;">{{potentialDuplicate.transaction.valueDate}}</th>
          <th style="width: 150px;">{{potentialDuplicate.transaction.calculatedAmount}}</th>
          <th style="width: 200px;">{{potentialDuplicate.transaction.createdAt}}</th>
          <th style="width: 100px;">{{potentialDuplicate.transaction.id}}</th>
          <td>{{potentialDuplicate.transaction.description}}</td>
        </tr>
        <tr *ngFor="let t of potentialDuplicate.potentialDuplicates">
          <td>-</td>
          <td>-</td>
          <td>{{t.createdAt}}</td>
          <td>{{t.id}}</td>
          <td>{{t.description}}</td>
        </tr>
      </table>
      <div class="spacer-small"></div>
    </div>
    <div class="spacer-large"></div>


    <!-- Transactieverdeling -->
    <h3>Transactieverdeling</h3>
    <textarea class="mono-space">{{account.transactionCountPerDay | json}}</textarea>
    <div class="spacer-large"></div>
  </div>
</div>
